// This is WatchlistTable.js
import React, { useContext } from 'react';
 import { useNavigate } from 'react-router-dom';

import InfoTooltip from './InfoTooltip';
import FinancialRatioStatus, { FinancialRatioValue } from './FinancialRatioStatus';
import MetricSelector from './MetricSelector';
import definitions from '../constants/metricsDefinitions';
import './WatchlistTable.css';
import { WatchlistContext } from '../contexts/StockWatchlistContext';
import { StockComparisonContext } from '../contexts/StockComparisonContext';
import { METRIC_FIELDS } from '../constants/metricFields';


// All available metrics
// All available metrics for the watchlist metric picker
// Derived from shared METRIC_FIELDS to keep everything in sync
const ALL_METRICS = METRIC_FIELDS.map(m => ({
  label: m.label,
  key: m.value
}));


const WatchlistTable = ({ 
  watchlistStocks, 
  results, 
  selectedMetrics, 
  setSelectedMetrics, 
  removeFromWatchlist
}) => {
    // Get selection state and functions from context
  const { selectedForComparison, toggleSelection, clearSelection } = useContext(WatchlistContext);
  const { setStocksFromWatchlist } = useContext(StockComparisonContext);
  const navigate = useNavigate();

  // Handle comparison of selected stocks
  const handleCompare = () => {
    if (selectedForComparison.length === 0) return;
    
    // Set the stocks in the comparison context
    setStocksFromWatchlist(selectedForComparison);
    
    // Clear selection from local storage
    clearSelection();
    
    // Navigate to comparison page
    navigate('/comparison');
  };



  return (
    <div className="table-container">

      <div className="watchlist-actions">
        <button 
          className="compare-btn"
          disabled={selectedForComparison.length === 0}
          onClick={handleCompare}
        >
          Compare Selected ({selectedForComparison.length})
        </button>
      </div>


      <MetricSelector
        id="watchlist-metric-selector"
        metrics={ALL_METRICS}
        selectedMetrics={selectedMetrics}
        setSelectedMetrics={setSelectedMetrics}
      />

      <div className="table-scroll">
        <table className="watchlist-table">
          <thead>
            <tr>
            <th className="select-column">Select</th>

              <th className="stock-column">Stock</th>
              {selectedMetrics.map(metric => (
                <th key={metric.key} className="metric-column">
                  <div className="metric-header">
                    {metric.label}
                    <InfoTooltip text={definitions[metric.key] || "No description"} />
                  </div>
                </th>
              ))}
              <th className="action-column">Actions</th>
            </tr>
          </thead>
          <tbody>
            {watchlistStocks.map(stock => (
              <tr key={stock}>

                <td className="select-cell">
                  <input
                    type="checkbox"
                    checked={selectedForComparison.includes(stock)}
                    onChange={() => toggleSelection(stock)}
                  />
                </td>

                <td className="stock-cell">{stock}<FinancialRatioStatus result={results[stock]} /></td>
                {selectedMetrics.map(metric => (
                  <td key={`${stock}-${metric.key}`} className="metric-cell">
                    <FinancialRatioValue result={results[stock]} metric={metric.key} />
                  </td>
                ))}
                <td className="action-cell">
                  <button 
                    className="remove-button"
                    onClick={() => removeFromWatchlist(stock)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WatchlistTable;
